import type { WebSocketStatus } from '@hocuspocus/provider';

/**
 * How a returning tab recovers a Hocuspocus session: a socket that is down reconnects in place,
 * while a socket whose token was refused has to be reopened, because the server ignores a second
 * auth for the document on the same socket. Anything else is live or already connecting.
 *
 * One rule for both collaboration planes — the PDF annotation layer (`useAnnotations`, #870) and
 * every rich-text field (`useCollaborativeEditor`, #979) — so a page's sessions recover together.
 */
export type CollabSessionRecovery = 'connect' | 'reopen' | null;

// The status is typed by its values so this module stays free of the provider's runtime, whose
// yjs/lib0 ESM the unit tests cannot load.
export const getCollabSessionRecovery = ({
  socketStatus,
  hasAuthFailed,
}: {
  socketStatus: `${WebSocketStatus}`;
  hasAuthFailed: boolean;
}): CollabSessionRecovery => {
  if (socketStatus === 'disconnected') return 'connect';
  if (socketStatus === 'connected' && hasAuthFailed) return 'reopen';
  return null;
};
